import { ContentAnimation } from './contentAnimation';
import { IContentOptions } from './content';
import { projectInterface } from '../Tool/interface';
import { PatternLight } from './Pattern/patternLight';
import { SystemLayer } from '../System/systemLayer';

/*
  +------------------------------------------------------------------------+
  | LIGHT CONTENT                                                          |
  +------------------------------------------------------------------------+
*/

export interface ILightOptions {
    color?: number[];
    intensity?: number;
    specularIntensity?: number;
    shadowdarkness?: number;
    shadowsoftness?: number;
}

projectInterface.light = {
    color: 'c',
    intensity: 'it',
    specularIntensity: 'sit',
    shadowdarkness: 'sd',
    shadowsoftness: 'ss',
};

export class ContentLight extends ContentAnimation {
    public type = 'light';

    public color: number[];

    public intensity: number;

    // Specular activated by default
    public specularIntensity = 1;

    public castshadow: boolean;

    public shadowdarkness: number;

    public shadowsoftness: number;

    public patternLight: PatternLight;

    constructor(systemLayer: SystemLayer, content: IContentOptions, lightOptions: ILightOptions) {
        super(systemLayer, content, 'light');
        this.patternLight = this.pattern as PatternLight;
        this.setTypeParameter(lightOptions);
        this.setScaleAnimationAvailable(false);
    }

    public setTypeParameter(lightOptions: ILightOptions): void {
        this.checkLightOption(lightOptions);
    }

    private checkLightOption(lO: ILightOptions) {
        if (lO.color !== undefined) this.setColor(lO.color);
        if (lO.intensity !== undefined) this.setIntensity(lO.intensity);
        if (lO.specularIntensity !== undefined) this.setSpecularIntensity(lO.specularIntensity);
        if (lO.shadowdarkness !== undefined) this.setShadowDarkness(lO.shadowdarkness);
        // Softness only used for shadow ground
        // if (lO.shadowsoftness !== undefined) this.setShadowSoftness(lO.shadowsoftness);
    }

    public setIntensity(intensity: number): void {
        this.intensity = intensity;
        this.patternLight.setIntensity(intensity);
    }

    public setSpecularIntensity(intensity: number): void {
        this.specularIntensity = intensity;
        this.patternLight.setSpecularIntensity(intensity);
    }

    public setColor(color: number[]): void {
        this.color = color;
        this.patternLight.setColor(color);
    }

    public setShadowDarkness(darkness: number): void {
        this.shadowdarkness = darkness;
        if (darkness === undefined) darkness = 0;
        this.patternLight.setShadowDarkness(darkness);
    }

    public setShadowSoftness(softness: number): void {
        this.shadowsoftness = softness;
        if (softness === undefined) softness = 0;
        this.patternLight.setShadowSoftness(softness);
    }

    // Prevent scale update of light
    public setScale(): void {
        return null;
    }
}
